import { useEffect } from 'react';
import { useInRouterContext, useParams } from 'react-router-dom';
import { AppLoader } from '../app-loader/AppLoader';
import { AppErrorScreen } from '../app-loader/AppErrorScreen';
import { updateManifestLink } from '../sw/manifestLink';
import { config } from '../config';

// Production: shell does not wrap /app/* paths in a BrowserRouter (apps
// mount their own — see App.tsx for the contract). Without router context,
// `useParams` returns empty, so we fall back to parsing the slug from
// window.location.pathname. Tests still mount AppRoute inside a
// MemoryRouter and rely on useParams; the conditional preserves both.
function getSlugFromPath(): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const m = window.location.pathname.match(/^\/app\/([^/]+)/);
  return m?.[1];
}

function useSlug(): string | undefined {
  // useInRouterContext + useParams are both stable hooks; call both
  // unconditionally to satisfy the rules-of-hooks lint and only use the
  // result when meaningful.
  const inRouter = useInRouterContext();
  const params = useParams<{ slug: string }>();
  if (inRouter && params.slug) return params.slug;
  return getSlugFromPath();
}

export function AppRoute() {
  const slug = useSlug();

  // P15: aponta <link rel="manifest"> pro endpoint dinâmico do slug atual.
  // URL absoluta pro API (manifest é servido pelo backend, não shell; SPA
  // catch-all devolveria HTML). Ver manifestLink.ts pra detalhes.
  useEffect(() => {
    if (slug) updateManifestLink(slug, config.apiHost);
  }, [slug]);

  if (!slug) {
    return (
      <AppErrorScreen
        code="app.not_found"
        onRetry={() => window.location.reload()}
      />
    );
  }
  return <AppLoader slug={slug} />;
}
